import { combineEpics, ofType } from 'redux-observable'
import { from, of } from 'rxjs'
import { catchError, map, mergeMap, pluck, startWith } from 'rxjs/operators'

import { fetchProfileSettings, patchProfileSettings } from 'api/userAPI'

import * as actions from './actions'

const fetchUserProfile = (action$) => {
  return action$.pipe(
    ofType(actions.fetchUserProfile.toString()),
    pluck('payload'),
    mergeMap((userId) =>
      from(fetchProfileSettings(userId)).pipe(
        startWith(actions.fetchUserProfilePending()),
        map((data) => actions.fetchUserProfileSuccess(data)),
        catchError((err) => of(actions.fetchUserProfileFailed({ err })))
      )
    )
  )
}

const patchUserProfile = (action$) => {
  return action$.pipe(
    ofType(actions.patchUserProfile.toString()),
    pluck('payload'),
    mergeMap(({ userId, newSettings }) => {
      return from(patchProfileSettings(userId, newSettings)).pipe(
        startWith(actions.patchUserProfilePending()),
        map((data) => actions.patchUserProfileSuccess(data)),
        catchError((err) => of(actions.patchUserProfileFailed({ err })))
      )
    })
  )
}

export default combineEpics(fetchUserProfile, patchUserProfile)
